import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=e68c4f78&"
import script from "./CategoryTree.vue?vue&type=script&lang=js&"
export * from "./CategoryTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,Slider: require('/~/src/components/Slider.vue').default})
